import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { CommonDataService } from '@app/services/common-data/common-data.service';
import { isEmbeddedInIframe } from '@app/utils/utils';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  commonDataService = inject(CommonDataService);

  isEmbedded = isEmbeddedInIframe();

  @HostBinding('style.display') get hostDisplay() {
    return this.isEmbedded ? 'none' : null;
  }
}
